



























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import {
  Configuration,
  TitleTemplatePublic,
  RedCapital,
  SelectedCountry
} from "@/configuration";
import API from "@/api";
import DniField from "@/components/DniFieldSimulation.vue";
import { isRutValid } from "@/utils";
import { EventBus } from "@/main";
import router from "@/router";

@Component({
  metaInfo: {
    title: "Datos Referidos",
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  props:['id'],
  data() {
    return {
      dialog3:false,
      dialog2:false,
      nombre:null,
      RedCapital,
      SelectedCountry,
      valid: true,
      dialog: false,
      errorMessage: null,
      codigo_enlace: "",
      sc_tiempo_id:null,
      rut: "",
      t_relacion_id: null,
      familiar: null,
      sc_13: null,
      sc_14: null,
      needSelected: 0,
      salesSelected: 0,
      averageSelected: 0,
      debt: null,
      propertyCost: null,
      propertyWarrantySelected: 0,
      propertyDebt: null,
      need: [
        {
          id: 1,
          text: `Entre 0 a 2 años`
        },
        {
          id: 2,
          text: `Entre 2 a 5 años`
        },
        {
          id: 3,
          text: `Entre 5 a 10 años`
        },
        {
          id: 4,
          text: `Sobre 10 años`
        }
      ],
      sales: [
        {
          id: 131,
          text: "Increíblemente confiable y responsable"
        },
        {
          id: 132,
          text: "Muy confiable y responsable"
        },
        {
          id: 133,
          text: "Confiable y responsable"
        },{
          id: 134,
          text: "Es buena persona, pero no es tan resposable"
        },{
          id: 135,
          text: "Poco responsable o confiable"
        }
      ],
      average: [
        {
          id: 141,
          // @ts-ignore
          text: 'De todas maneras'
        },
        {
          id: 142,
          // @ts-ignore
          text: 'Casi con toda seguridad'
        },
        {
          id: 143,
          // @ts-ignore
          text: 'Muy probablemente si'
        },
        {
          id: 144,
          // @ts-ignore
          text: 'Lo pensaría bien antes de prestarle'
        },
        {
          id: 145,
          // @ts-ignore
          text: 'Por ningún motivo'
        }
      ],
      relacion_items:[
          {
            id: 1,
            text: "Cliente"
          },{
            id: 2,
            text: "Proveedor / Arrendatario"
          },{
            id: 3,
            text: "Trabajador"
          }
      ],
      conoce_items:[
        {
          id:0,
          text: "No"
        },
        {
          id:1,
          text: "Si"
        }
      ],
      rules: {
        notEmpty: [(v: any) => !!v || "Ingrese un valor"],
        name: [
          (v: any) => !!v || "Ingrese nombre",
          (v: any) =>
            v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
        ],
        email: [
          (v: any) => !!v || "Ingrese correo electrónico",
          (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
        ],
        rut: [
          (v: any) =>
          // @ts-ignore
            !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          (v: any) =>
            /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(v) ||
            // @ts-ignore
            `${RedCapital[SelectedCountry].DniName} invalido Ej: 12.345.678-9`
        ],
        phone: [(v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros"]
      }
    };
  },
  beforeMount() {
    API.accion.eleven.getReferidos(this.$props.id)
    .then((res: any)=>{
      this.$data.nombre = res.data.data
    })
    .catch(err=>{
      
    })
  },
  methods: {
    async validate() {
      this.$data.dialog2 = true;
      let dni =  this.$data.rut.split('.').join('')
      // @ts-ignore
        this.$data.codigo_enlace= this.$route.params.id;
        API.accion.eleven.referido(
          this.$data.codigo_enlace,
          dni,
          this.$data.t_relacion_id,
          this.$data.sc_tiempo_id,
          this.$data.familiar,
          this.$data.sc_13,
          this.$data.sc_14,
        )
          .then(res => {
             this.$data.dialog2 = false;
             this.$data.dialog3 = true;
             EventBus.$emit("snack-success", "Datos registrados correctamente");
             setTimeout(() => {
               this.$data.dialog3 = false;
               this.$router.push("/")
             },1500)
          })
          .catch((error: any) => {
            this.$data.dialog2 = false;
            EventBus.$emit("snack-error", 'Enlace ya procesado o no encontrado');
          });
      
    }
  },
  components: {
    DniField
  }
})
export default class QuestionsReferidos extends Vue {}
